<template>
    <slick class="miniStoreSlide" ref="slickfive" v-if="data.length" :options="slickOptions">
        <div class="store-grid-2" v-for="(item, i) in data" :key="i">
          <router-link
            :to="{ name: 'list', query: { store: $route.query.store, category:item.category_id,
                   name:item.category_name, isFromStore:true },
                   params: {
                      menu_url_key: `store-${$route.query.store}`
                    } }"
          >
            <img :src="item.img_path" alt="" class="w-100" title="" />
              <!-- <img src="/cb/8.jpg" alt="" class="w-100" title="" />
                <img src="/cb/9.jpg" alt="" class="w-100" title="" /> -->
                <a v-if="item.category_name.length > 1" href="#" class="grid-2-btn centerButton">
                    {{ item.category_name }}
                </a>
          </router-link>
        </div>
      </slick>
</template>
<style>
    .miniStoreSlide .slick-slide{
        padding:10px ;
    }
</style>
<script>
import slick from "vue-slick";
export default {
    components: { slick },
    props:["data"],
    
   data() {
    return {
        slickOptions: { 
        	arrows: false,
            slidesToShow: 1.10,
            slidesToScroll: 1, 
            infinite: true,
            dot: true,
        // draggable:true,
        // swipeToSlide:true,
        // touchMove:true
        // Any other options that can be got from plugin documentation
      },
      isMenu:false
    }
  
    },
     
   
}
</script>